import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables'
import axios from 'axios';

const API_URL = global.SET_API_URL + 'sr/'

const initialState = {
  reportRows: [],
  summary: {
    totalOrders: 0,
    totalAmount: 0,
    completedOrders: 0,
    activeOrders: 0,
    draftOrders: 0,
    dineInAmount: 0,
    takeawayAmount: 0,
    dispatchAmount: 0,
    deliveryAmount: 0,
    foodpandaAmount: 0,
    employeeAmount: 0,
    employeeOrders: 0,
    averageOrderAmount: 0,
  },
  paymentMethodOptions: [],
  userOptions: [],
  itemConsumptionSummary: [],
  categorySalesSummary: [],
  detailReport: {
    salesByType: { dineIn: 0, takeaway: 0, foodpanda: 0, orderKarachi: 0 },
    users: [],
  },
  loading: false,
  error: '',
};

export const getAdvancedSalesReport = createAsyncThunk('sr/advanced', async (filters, thunkAPI) => {
  try {
    const response = await axios.post(API_URL + 'getAdvancedSalesReport', filters || {});
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const salesReportSlice = createSlice({
  name: 'salesReport',
  initialState,
  reducers: {
    resetSalesReport: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdvancedSalesReport.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getAdvancedSalesReport.fulfilled, (state, action) => {
        state.loading = false;
        state.reportRows = action.payload?.rows || [];
        state.summary = action.payload?.summary || initialState.summary;
        state.paymentMethodOptions = action.payload?.paymentMethodOptions || [];
        state.userOptions = action.payload?.userOptions || [];
        state.itemConsumptionSummary = action.payload?.itemConsumptionSummary || [];
        state.categorySalesSummary = action.payload?.categorySalesSummary || [];
        state.detailReport = action.payload?.detailReport || initialState.detailReport;
      })
      .addCase(getAdvancedSalesReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load sales report';
      })
  }
});

export const { resetSalesReport } = salesReportSlice.actions;
export default salesReportSlice.reducer;

